import React, { useRef, useState } from "react";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, IconButton, Radio, RadioGroup, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from "react-i18next";
import { altChooseButtonStyleTurquoise, altCloseButtonStyleDark } from "../styles/buttonStyles";
import ServiceWorkOrder from "./ServiceWorkOrder";
import { useReactToPrint } from "react-to-print";
import { dialogStyle } from "../styles/dialogStyles";
import { getStatus } from "../utils/reservation";


const options = [
  { value: "custom", label: "Custom" },
  { value: "ai_generated", label: "AI Generated" },
];
const ReservationConfirmDialog = ({ open, onClose, onConfirm, reservation }) => {
  const { t } = useTranslation();
  const [selected, setSelected] = useState("custom");
  const printRef = useRef(null);
  const documentTitle = `workorder-${reservation.PK.split("-")[0].split("#")[1]}-${reservation.date.split("-").join("")}`;
  const status = getStatus(reservation.status);

  const handlePrint = useReactToPrint({
    contentRef: printRef,
    documentTitle,
    pageStyle: `
      @page { size: A4; margin: 10mm; }
      @media print {
        html, body { margin: 0; }
        * { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
      }
    `,
    onAfterPrint: () => onConfirm?.(selected),
  });

  return (
    <Dialog open={open} onClose={onClose} maxWidth='lg' fullWidth scroll='paper' sx={{ ...dialogStyle }}>
      <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
        <Box>
          <Typography variant='h6' sx={{ fontWeight: "bold", color: "#003C59" }}>
            {t("workOrder.dialogTitle")}
          </Typography>
          <Typography variant='body2' sx={{ marginTop: 1, color: "#003C59" }}>
            {t("workOrder.dialogDescription")}
          </Typography>
        </Box>
        <IconButton onClick={onClose} sx={{ padding: 0, marginTop: "-4px" }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        <RadioGroup value={selected} onChange={(e) => setSelected(e.target.value)} name='workorder-option'>
          <Box sx={{ display: "flex", flexDirection: { xs: "column", md: "row" }, gap: 2 }}>
            {options.map((option) => {
              const active = selected === option.value;
              return (
                <Box
                  key={option.value}
                  onClick={() => setSelected(option.value)}
                  sx={{
                    flex: 1,
                    minWidth: 0,
                    p: 1.5,
                    cursor: "pointer",
                    borderRadius: 2,
                    border: "2px solid",
                    borderColor: active ? "#003C59" : "divider",
                    transition: "border-color 0.15s",
                  }}
                >
                  <FormControlLabel value={option.value} control={<Radio />} label={t(`workOrder.${option.value}`)} sx={{ mb: 1 }} />
                  <ServiceWorkOrder reservation={reservation} ref={active ? printRef : null} />
                </Box>
              );
            })}
          </Box>
        </RadioGroup>
      </DialogContent>

      <DialogActions
        sx={{
          position: "sticky",
          bottom: 0,
          backgroundColor: "#003C59",
          borderTop: "1px solid rgba(255, 255, 255, 0.1)",
          padding: "16px 24px",
          gap: 2,
          zIndex: 1,
        }}
      >
        <Button onClick={onClose} variant='outlined' sx={{ ...altCloseButtonStyleDark, flex: 1 }}>
          {t("common.cancel")}
        </Button>
        <Button onClick={handlePrint} variant='contained' sx={{ ...altChooseButtonStyleTurquoise, flex: 1 }}>
          {status === "Confirmed" ? t("common.print") : t("common.confirm")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ReservationConfirmDialog;
